import React, { useEffect, useState } from "react";
import BTN from "../../Master/BTN";
import {
  homeSlice,
  useGetOrderDataQuery,
} from "../../../redux/slices/homeSlice";
import LOADER from "../../Master/LOADER";
import { fakeData } from "../../../json";
import Skeleton from "react-loading-skeleton";
import MODEL from "../../Master/MODEL";
import { CLOSE_BLACK_IC } from "../../../assets";
import { useDispatch } from "react-redux";

const OrderHistory = () => {
  const [orderType, setOrderType] = useState("");
  const user = localStorage.getItem("user");
  const dispatch = useDispatch();

  const {
    data: customerOrderData,
    isSuccess: customerOrderDataIsSuccess,
    isLoading: customerOrderDataIsLoading,
    isError: customerOrderDataIsError,
    error: customerOrderDataError,
  } = useGetOrderDataQuery(
    { user: user, orderType: orderType },
    { skip: !user }
  );

  const [orderData, setOrderData] = useState([]);

  useEffect(() => {
    if (customerOrderDataIsSuccess) {
      const { orders } = customerOrderData;
      setOrderData(orders);
    }
  }, [customerOrderData, customerOrderDataIsSuccess]);

  return (
    <div className="w-full overflow-hidden flex flex-col lato-regular">
      <div className="flex items-center justify-between pb-4 border-b border-light_secondary mb-5">
        <span className="text-2xl font-bold ">Order History</span>
      </div>
      <div className="w-full flex flex-col items-center justify-center">
        {/* ====================== EMPTY SCREEN UI ======================== */}
        {/* <div className="mt-5 w-full flex flex-col items-center justify-center">
          <span className="mt-10 text-center text-4xl text-[#44444499]">You have not placed any order yet</span>
          <BTN title="START SHOPPING" bordered className="mt-7 px-5 py-1 w-fit rounded-none" />
        </div> */}
        {/* =============================================================== */}
        {/* <div className="w-full select-none my-7 flex items-center justify-start hide_scrollbar overflow-x-auto overflow-y-hidden">
          <div
            className={`px-4 py-1 text-center cursor-pointer text-nowrap ${
              orderType === ""
                ? "bg-primary text-text_light_3"
                : "border border-primary text-primary"
            }`}
            onClick={() => setOrderType("")}
          >
            All Orders
          </div>
          <div
            className={`px-4 py-1 text-center cursor-pointer text-nowrap ms-4 ${
              orderType === "online"
                ? "bg-primary text-text_light_3"
                : "border border-primary text-primary"
            }`}
            onClick={() => setOrderType("online")}
          >
            Online Orders
          </div>
          <div
            className={`px-4 py-1 text-center cursor-pointer text-nowrap ms-4 ${
              orderType === "instore"
                ? "bg-primary text-text_light_3"
                : "border border-primary text-primary"
            }`}
            onClick={() => setOrderType("instore")}
          >
            In Store Orders
          </div>
        </div> */}

        <div className="w-full flex flex-col items-center">
          {/* ============================== FOR LG [ loop through customerOrderData.orders and display each orders.cart ] =============================== */}

          {/* <div className="w-full h-[30dvh] flex flex-col items-center justify-center">
              <LOADER isLoading={customerOrderDataIsLoading} />
            </div> */}
          {customerOrderDataIsLoading
            ? fakeData?.map((item, index) => {
                return (
                  <div className="w-full">
                    <div className="w-full mb-5 lg:flex emd:hidden small:hidden items-start justify-between pb-2 border-b border-light_secondary">
                      <div className="w-1/3 flex items-center justify-center overflow-hidden bg-bg_1">
                        <Skeleton className="w-[250px] h-[200px] object-contain" />
                      </div>
                      <div className="flex flex-col items-start justify-between w-[64%] h-[200px] overflow-hidden">
                        <div className="w-full flex items-start justify-center">
                          <div className="w-full flex flex-col">
                            <span className="text-lg font-semibold w-1/2">
                              <Skeleton count={1} />
                            </span>
                            <span className="text-sm w-1/2">
                              <Skeleton count={1} />
                            </span>
                            <span className="text-sm w-1/2">
                              <Skeleton count={1} />
                            </span>
                            {/* <span className="text-lg mt-5"> ₹{data?.cart[0]?.price}</span> */}
                          </div>
                          <div className="flex flex-col w-1/2">
                            <Skeleton className="uppercase w-44 py-1.5 px-5 rounded-none text-sm" />
                            <Skeleton className="uppercase w-44 py-1.5 px-5 rounded-none text-sm lg:mt-4 emd:mt-0 small:mt-0" />
                          </div>
                        </div>
                        <div className="w-full">
                          <div className="mb-1 ">
                            <Skeleton count={1} />
                          </div>
                          <div className="w-full border-light_secondary border-t pt-4">
                            <Skeleton count={1} />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ===================================================================== */}
                    <div className="w-full mt-5 lg:hidden emd:flex small:flex items-start flex-col justify-between border-b border-light_secondary">
                      <div className="w-full flex justify-between">
                        <div className="w-[58%] flex items-center justify-center overflow-hidden bg-bg_1">
                          <Skeleton className="w-fit h-[200px] object-contain" />
                        </div>
                        <div className="w-[38%] flex flex-col">
                          <span className="text-lg font-semibold">
                            <Skeleton count={1} />
                          </span>
                          <span className="text-sm w-1/2">
                            <Skeleton count={1} />
                          </span>
                          <span className="text-sm w-1/2">
                            <Skeleton count={1} />
                          </span>
                          {/* <span className="text-lg mt-5">₹{data?.cart[0]?.price}</span> */}
                        </div>
                      </div>
                      <div className="w-full border-light_secondary border-t mt-4 pt-4">
                        <span className="text-base text-primary">
                          <Skeleton count={1} />
                        </span>
                      </div>
                      <div className="w-full my-5 flex justify-between items-center">
                        <Skeleton className="uppercase w-44 py-1.5 px-5 rounded-none text-sm" />
                        <Skeleton className="uppercase w-44 py-1.5 px-5 rounded-none text-sm lg:mt-4 emd:mt-0 small:mt-0 ms-1" />
                      </div>
                    </div>
                  </div>
                );
              })
            : orderData &&
              orderData?.length > 0 &&
              orderData?.map((item) => {
                return item?.cart?.map((cartItem, index) => {
                  if (index === 0) {
                    return (
                      <OrderHistoryCard
                        data={{ ...item, cart: [cartItem] }}
                        key={item._id}
                      />
                    );
                  } else {
                    return (
                      <OrderHistoryCard
                        data={{ ...item, cart: [cartItem] }}
                        key={item._id + index}
                      />
                    );
                  }
                });
              })}
        </div>
      </div>
    </div>
  );
};

export default OrderHistory;

function OrderHistoryCard({ data }) {
  const [selectedShowPrescription, setSelectedShowPrescription] =
    useState(null);
  const estimatedDeliveryDate = new Date(data?.createdAt);
  estimatedDeliveryDate.setDate(estimatedDeliveryDate.getDate() + 7);
  const options = { year: "numeric", month: "long", day: "numeric" };
  const formattedEstimatedDeliveryDate =
    estimatedDeliveryDate.toLocaleDateString("en-GB", options);

  //return and exchange buttton should be visible only until 10 days of order placed
  const [showReturnExchangeButton, setShowReturnExchangeButton] =
    useState(false);
  const orderUpdatedTimestamp = data.updatedAt;
  useEffect(() => {
    const checkReturnExchangeButtonVisibility = () => {
      const orderTime = new Date(orderUpdatedTimestamp);
      const currentTime = new Date();
      const timeDifference = currentTime - orderTime; // Difference in milliseconds

      const tenDays = 14 * 24 * 60 * 60 * 1000; // 10 days in milliseconds

      if (timeDifference <= tenDays) {
        setShowReturnExchangeButton(true);
      } else {
        setShowReturnExchangeButton(false);
      }
    };

    // Check the button visibility on component mount
    checkReturnExchangeButtonVisibility();

    // Optionally, set an interval to check periodically
    const intervalId = setInterval(checkReturnExchangeButtonVisibility, 1000); // Check every second

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [orderUpdatedTimestamp]);

  const formatedSchedualeDeliveryDate = (dateStr) => {
    const date = new Date(dateStr);
    // Extract day, month, and year
    const day = date.getDate().toString().padStart(2, "0"); // Ensures two-digit day
    const month = date.toLocaleString("default", { month: "long" }); // Gets full month name
    const year = date.getFullYear();

    const formattedDate = `${day} ${month} ${year}`;
    return formattedDate;
  };

  const isMoreThan24Hours = (timestamp) => {
    const givenTime = new Date(timestamp).getTime();
    const currentTime = new Date().getTime();

    const timeDifference = currentTime - givenTime;
    const twentyFourHoursInMilliseconds = 24 * 60 * 60 * 1000;

    return timeDifference > twentyFourHoursInMilliseconds;
  };

  return (
    <div className="w-full bg-bg_1 p-5 mb-5 flex flex-col lato-regular">
      <div className="flex w-full">
        <div
          className="lg:min-w-[200px] lg:max-w-[200px] lg:min-h-[160px] lg:max-h-[160px]
    emd:min-w-[200px] emd:max-w-[200px] emd:min-h-[160px] emd:max-h-[160px]
    small:min-w-[120px] small:max-w-[120px] small:min-h-[100px] small:max-h-[100px] object-contain flex items-center justify-center overflow-hidden bg-white"
        >
          <img
            src={
              data?.cart[0]?.images?.[0]?.length > 0
                ? data?.cart[0]?.images?.[0]?.replace(
                    "upload/",
                    "upload/if_w_gt_600/w_600/if_end/"
                  )
                : ""
            }
            className="lg:w-[180px] emd:w-[180px] small:w-[100px] aspect-square object-contain p-3 h-full"
            alt=""
          />
        </div>
        <div className="lg:w-[calc(100%-200px)] emd:w-[calc(100%-200px)] small:w-[calc(100%-120px)] flex justify-between overflow-hidden">
          <div className="pl-4 flex flex-col">
            <div className="w-full flex flex-col">
              <div className=" mb-1 lg:text-base emd:text-base small:text-sm">
                Order #{data?.invoice}
              </div>
              <span className="text-wrap lg:text-lg emd:text-lg small:text-sm">
                {data?.cart[0]?.title}
              </span>
              <span className="text-sm mt-3">
                Quantity : {data?.cart[0]?.quantity}
              </span>
              <span className="mt-3  text-xs">Order ID</span>
              <span className="mt-1 text-wrap  text-xs">
                {data?._id}
              </span>
            </div>
          </div>
          {data?.cart[0]?.orderStatus === "Not Placed" ||
          (!showReturnExchangeButton &&
            data?.cart[0]?.orderStatus === "Delivered") ? (
            <div className="lg:flex emd:hidden small:hidden uppercase w-44 py-1.5 justify-end  text-red-400 rounded-none text-sm text-center">
              order failed
            </div>
          ) : (
            <div className="lg:flex emd:hidden small:hidden flex-col">
              <BTN
                title={
                  data?.cart[0]?.orderStatus === "Placed" ||
                  data?.cart[0]?.orderStatus === "In Making" ||
                  data?.cart[0]?.orderStatus === "Prepared" ||
                  data?.cart[0]?.orderStatus === "Pending"
                    ? "Track Order"
                    : "Return"
                }
                bordered
                to={
                  data?.cart[0]?.orderStatus === "Placed" ||
                  data?.cart[0]?.orderStatus === "In Making" ||
                  data?.cart[0]?.orderStatus === "Prepared" ||
                  data?.cart[0]?.orderStatus === "Pending"
                    ? `/track-order/${data?.orderId}/${data?.cart[0]?.sku}`
                    : `/return-order/${data?.orderId}/${data?.cart[0]?.product_id}/${data?.cart[0]?.sku}`
                }
                className="uppercase w-44 py-1.5 px-5 rounded-none text-sm text-primary"
                disabled={
                  data?.cart[0]?.orderStatus === "Returned" ||
                  data?.cart[0]?.orderStatus === "Return Initiated" ||
                  data?.cart[0]?.orderStatus === "Exchange Initiated" ||
                  data?.cart[0]?.orderStatus === "Cancelled" ||
                  data?.cart[0]?.orderStatus === "Exchanged"
                }
              />

              <BTN
                title={
                  data?.cart[0]?.orderStatus === "Placed" ||
                  data?.cart[0]?.orderStatus === "In Making" ||
                  data?.cart[0]?.orderStatus === "Pending"
                    ? "Cancel Order"
                    : "Exchange"
                }
                bordered
                to={
                  data?.cart[0]?.orderStatus === "Placed" ||
                  data?.cart[0]?.orderStatus === "In Making" ||
                  data?.cart[0]?.orderStatus === "Prepared" ||
                  data?.cart[0]?.orderStatus === "Pending"
                    ? `/cancel-order/${data?.orderId}/${data?.cart[0]?.product_id}`
                    : `/exchange-order/${data?.orderId}/${data?.cart[0]?.product_id}/${data?.cart[0]?.sku}`
                }
                className="uppercase w-44 py-1.5 px-5 rounded-none text-sm lg:mt-4 emd:mt-0 small:mt-0 text-primary"
                disabled={
                  data?.cart[0]?.orderStatus === "Returned" ||
                  data?.cart[0]?.orderStatus === "Return Initiated" ||
                  data?.cart[0]?.orderStatus === "Exchange Initiated" ||
                  data?.cart[0]?.orderStatus === "Cancelled" ||
                  data?.cart[0]?.orderStatus === "Exchanged" ||
                  (data?.cart[0]?.orderStatus === "Placed" &&
                    isMoreThan24Hours(data?.createdAt))
                }
              />
            </div>
          )}
        </div>
      </div>

      {data?.cart[0]?.lensDetails?.length > 0 && (
        <div className="w-full flex flex-col mt-4">
          <div className=" w-full flex flex-col">
            <div className="text-base  uppercase">
              Lens Details ( {data?.cart[0]?.lensDetails?.length} Lens )
            </div>
            {data?.cart[0]?.lensDetails?.map((item, index) => {
              return (
                <div
                  key={index}
                  className="w-full flex justify-between items-center mt-2 pb-2"
                >
                  <div
                    className="flex items-center"
                    onClick={() =>
                      setSelectedShowPrescription(item?.prescription)
                    }
                  >
                    <span>{index + 1}.</span>
                    <span className="text-base ms-2 cursor-pointer">
                      {item.name + " Lens"} &nbsp;
                      {/* <span className="text-nowrap">(₹ {item.price})</span> */}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className="w-full lg:flex emd:hidden small:hidden justify-end">
        {data?.deliveryDate &&
        (data?.cart[0]?.orderStatus === "Placed" ||
          data?.cart[0]?.orderStatus === "In Making" ||
          data?.cart[0]?.orderStatus === "Prepared") ? (
          <span className="text-base text-primary">
            Your Scheduled delivery date is{" "}
            {formatedSchedualeDeliveryDate(data?.deliveryDate)}
          </span>
        ) : (
          <span className="text-base text-primary">
            {data?.cart[0]?.orderStatus === "Placed" ||
            data?.cart[0]?.orderStatus === "In Making" ||
            data?.cart[0]?.orderStatus === "Prepared"
              ? `Order ${data?.cart[0]?.orderStatus} : Estimated delivery by ${formattedEstimatedDeliveryDate}`
              : data?.cart[0]?.orderStatus === "Delivered"
              ? `Order ${data?.cart[0]?.orderStatus}`
              : `Order ${data?.cart[0]?.orderStatus}`}
          </span>
        )}
      </div>

      {data?.cart[0]?.orderStatus === "Not Placed" ||
      (!showReturnExchangeButton &&
        data?.cart[0]?.orderStatus === "Delivered") ? (
        <div className="w-full lg:hidden emd:flex small:flex text-center uppercase pt-3 border-t border-dashed border-light_secondary justify-start text-red-400 rounded-none text-sm">
          order failed
        </div>
      ) : (
        <div className="border-t border-dashed border-light_secondary mt-2 pt-5 lg:hidden emd:flex small:flex flex-col justify-between">
          <div className="w-full mb-4">
            {data?.deliveryDate &&
            (data?.cart[0]?.orderStatus === "Placed" ||
              data?.cart[0]?.orderStatus === "In Making" ||
              data?.cart[0]?.orderStatus === "Prepared") ? (
              <span className="text-base text-primary">
                Your Scheduled delivery date is{" "}
                {formatedSchedualeDeliveryDate(data?.deliveryDate)}
              </span>
            ) : (
              <span className="text-base text-primary">
                {data?.cart[0]?.orderStatus === "Placed" ||
                data?.cart[0]?.orderStatus === "In Making" ||
                data?.cart[0]?.orderStatus === "Prepared"
                  ? `Order ${data?.cart[0]?.orderStatus} : Estimated delivery by ${formattedEstimatedDeliveryDate}`
                  : data?.cart[0]?.orderStatus === "Delivered"
                  ? `Order ${data?.cart[0]?.orderStatus}`
                  : `Order ${data?.cart[0]?.orderStatus}`}
              </span>
            )}
          </div>
          <div className="w-full flex items-center justify-between">
            <BTN
              title={
                data?.cart[0]?.orderStatus === "Placed" ||
                data?.cart[0]?.orderStatus === "In Making" ||
                data?.cart[0]?.orderStatus === "Prepared" ||
                data?.cart[0]?.orderStatus === "Pending"
                  ? "Track Order"
                  : "Return"
              }
              bordered
              to={
                data?.cart[0]?.orderStatus === "Placed" ||
                data?.cart[0]?.orderStatus === "In Making" ||
                data?.cart[0]?.orderStatus === "Prepared" ||
                data?.cart[0]?.orderStatus === "Pending"
                  ? `/track-order/${data?.orderId}/${data?.cart[0]?.sku}`
                  : `/return-order/${data?.orderId}/${data?.cart[0]?.product_id}/${data?.cart[0]?.sku}`
              }
              className="uppercase w-fit py-1.5 emd:px-5 small:px-1.5 rounded-none emd:text-sm small:text-xs"
              disabled={
                data?.cart[0]?.orderStatus === "Returned" ||
                data?.cart[0]?.orderStatus === "Return Initiated" ||
                data?.cart[0]?.orderStatus === "Exchange Initiated" ||
                data?.cart[0]?.orderStatus === "Cancelled" ||
                data?.cart[0]?.orderStatus === "Exchanged"
              }
            />

            <BTN
              title={
                data?.cart[0]?.orderStatus === "Placed" ||
                data?.cart[0]?.orderStatus === "In Making" ||
                data?.cart[0]?.orderStatus === "Pending"
                  ? "Cancel Order"
                  : "Exchange"
              }
              bordered
              to={
                data?.cart[0]?.orderStatus === "Placed" ||
                data?.cart[0]?.orderStatus === "In Making" ||
                data?.cart[0]?.orderStatus === "Prepared" ||
                data?.cart[0]?.orderStatus === "Pending"
                  ? `/cancel-order/${data?.orderId}/${data?.cart[0]?.product_id}`
                  : `/exchange-order/${data?.orderId}/${data?.cart[0]?.product_id}/${data?.cart[0]?.sku}`
              }
              className="uppercase w-fit py-1.5 emd:px-5 small:px-1.5 rounded-none emd:text-sm small:text-xs lg:mt-4 emd:mt-0 small:mt-0 ms-1"
              disabled={
                data?.cart[0]?.orderStatus === "Returned" ||
                data?.cart[0]?.orderStatus === "Return Initiated" ||
                data?.cart[0]?.orderStatus === "Exchange Initiated" ||
                data?.cart[0]?.orderStatus === "Cancelled" ||
                data?.cart[0]?.orderStatus === "Exchanged" ||
                (data?.cart[0]?.orderStatus === "Placed" &&
                  isMoreThan24Hours(data?.createdAt))
              }
            />
          </div>
        </div>
      )}

      {/* =================== PRESCRIPTION DETAILS MODEL =============== */}
      <MODEL
        setShowModel={() => setSelectedShowPrescription(null)}
        showModel={selectedShowPrescription !== null}
        isDialogue={true}
      >
        <div className="w-full flex flex-col items-center">
          <div className="w-full flex justify-between bg-bg_1 px-5 py-5">
            <span className=" text-xl ">Prescription details</span>
            <img
              src={CLOSE_BLACK_IC}
              alt=""
              className="cursor-pointer"
              onClick={() => setSelectedShowPrescription(null)}
            />
          </div>
          <div className="w-full my-5 px-5">
            <div className="xl:flex-row emd:flex-row small:flex-col fix_lg:flex-col flex items-center justify-between">
              <div className="xl:w-[49%] emd:w-[49%] small:w-full fix_lg:w-full h-40 flex flex-col justify-evenly items-center xl:border-r emd:border-r small:border-b fix_lg:border-b xl:border-b-0 emd:border-b-0 small:border-r-0 fix_lg:border-r-0 border-light_secondary  xl:pr-3 fix_lg:pr-0 emd:pr-3 small:pr-0 xl:pb-0 emd:pb-0 small:pb-2 fix_lg:pb-2">
                <div className="my-2 text-center font-bold underline underline-offset-4">
                  Left Eye
                </div>
                <div className="w-full flex items-center justify-between mt-3">
                  <span className="text-sm font-bold">Sphere :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.leftEye?.sphere}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">Cylinder :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.leftEye?.cylinder}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">Axis :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.leftEye?.axis}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">PD :</span>
                  <div className="flex items-center">
                    <span className="text-sm">
                      {selectedShowPrescription?.leftEye?.pd}
                    </span>
                    {/* <span className="text-sm ms-2">
                          {selectedShowPrescription?.leftEye?.left_pd}
                        </span> */}
                  </div>
                </div>
                {selectedShowPrescription?.leftEye?.add && (
                  <div className="w-full flex items-center justify-between">
                    <span className="text-sm font-bold">ADD :</span>
                    <div className="flex items-center">
                      <span className="text-sm">
                        {selectedShowPrescription?.leftEye?.add}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div className="xl:w-[49%] emd:w-[49%] small:w-full fix_lg:w-full h-40 lg:pl-3 fix_lg:pl-0 emd:pl-3 small:pl-0 flex flex-col justify-evenly items-center">
                <div className="my-2 text-center font-bold underline underline-offset-4">
                  Right Eye
                </div>
                <div className="w-full flex items-center justify-between mt-3">
                  <span className="text-sm font-bold">Sphere :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.rightEye?.sphere}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">Cylinder :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.rightEye?.cylinder}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">Axis :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.rightEye?.axis}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">PD :</span>
                  <div className="flex items-center">
                    <span className="text-sm">
                      {selectedShowPrescription?.rightEye?.pd}
                    </span>
                    {/* <span className="text-sm ms-2">
                          {item?.leftEye?.right_pd}
                        </span> */}
                  </div>
                </div>
                {selectedShowPrescription?.rightEye?.add && (
                  <div className="w-full flex items-center justify-between">
                    <span className="text-sm font-bold">ADD :</span>
                    <div className="flex items-center">
                      <span className="text-sm">
                        {selectedShowPrescription?.rightEye?.add}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </MODEL>
    </div>
  );
}

// ["Placed" , "Delivered" , "Returned" , "Return Initiated", "Exchanged", "Exchange Initiated", "Cancelled"]

// ["Placed" ,
//  "In Making" ,
//   "Prepared" ,
//    "Delivered" ,
//     "Returned" ,
//      "Return Initiated",
//       "Exchanged",
//        "Exchange Initiated",
//         "Cancelled"]

// ====================================

{
  /* <div className="w-full lg:flex emd:hidden small:hidden n flex-col mb-5  bg-bg_1 p-8">
<div className="w-full lg:flex emd:hidden small:hidden items-start justify-between">
  <div className="w-1/3 flex flex-col items-center justify-center overflow-hidden">
    <img
      src={data?.cart[0]?.images?.[0].replace(
        "upload/",
        "upload/if_w_gt_300/w_300/if_end/"
      )}
      alt=""
      className="w-[250px] h-[150px] object-contain bg-bg_1"
    />
    {data?.cart[0]?.lensDetails && (
      <div className="flex flex-col items-center justify-center w-full">
        <div className="text-3xl pt-1 bg-[#dfdfe0] rounded-full min-w-[30px] max-w-[30px] min-h-[30px] max-h-[30px] flex items-center justify-center text-center">
          +
        </div>
        <img
          src={data?.cart[0]?.lensDetails[0]?.image}
          alt=""
          className="min-w-[50px] max-w-[50px] mt-8 bg-bg_1"
        />
      </div>
    )}
  </div>
  <div className="flex flex-col items-start justify-between w-[64%] min-h-[150px] overflow-hidden">
    <div className="w-full flex items-start justify-center">
      <div className="w-full flex flex-col">
        <div className=" mb-1">Order #{data?.invoice}</div>
        <span className="text-lg font-semibold">
          {data?.cart[0]?.title}
        </span>
        <span className="text-sm">SKU : {data?.cart[0]?.sku}</span>
        <span className="text-sm">
          Quantity : {data?.cart[0]?.quantity}
        </span>
      </div>
      {data?.cart[0]?.orderStatus === "Not Placed" ||
      (!showReturnExchangeButton &&
        data?.cart[0]?.orderStatus === "Delivered") ? (
        <div className="flex text-center"></div>
      ) : (
        <div className="flex flex-col">
          <div className="mb-1 text-xs">Order ID</div>
          <div className="mb-1 text-xs">&nbsp;{data?._id}</div>
          <BTN
            title={
              data?.cart[0]?.orderStatus === "Placed" ||
              data?.cart[0]?.orderStatus === "In Making" ||
              data?.cart[0]?.orderStatus === "Prepared" ||
              data?.cart[0]?.orderStatus === "Pending"
                ? "Track Order"
                : "Return"
            }
            bordered
            to={
              data?.cart[0]?.orderStatus === "Placed" ||
              data?.cart[0]?.orderStatus === "In Making" ||
              data?.cart[0]?.orderStatus === "Prepared" ||
              data?.cart[0]?.orderStatus === "Pending"
                ? `/track-order/${data?.orderId}/${data?.cart[0]?.sku}`
                : `/return-order/${data?.orderId}/${data?.cart[0]?.product_id}/${data?.cart[0]?.sku}`
            }
            className="uppercase w-44 py-1.5 px-5 rounded-none text-sm"
            disabled={
              data?.cart[0]?.orderStatus === "Returned" ||
              data?.cart[0]?.orderStatus === "Return Initiated" ||
              data?.cart[0]?.orderStatus === "Exchange Initiated" ||
              data?.cart[0]?.orderStatus === "Cancelled" ||
              data?.cart[0]?.orderStatus === "Exchanged"
            }
          />

          <BTN
            title={
              data?.cart[0]?.orderStatus === "Placed" ||
              data?.cart[0]?.orderStatus === "In Making" ||
              data?.cart[0]?.orderStatus === "Pending"
                ? "Cancel Order"
                : "Exchange"
            }
            bordered
            to={
              data?.cart[0]?.orderStatus === "Placed" ||
              data?.cart[0]?.orderStatus === "In Making" ||
              data?.cart[0]?.orderStatus === "Prepared" ||
              data?.cart[0]?.orderStatus === "Pending"
                ? `/cancel-order/${data?.orderId}/${data?.cart[0]?.product_id}`
                : `/exchange-order/${data?.orderId}/${data?.cart[0]?.product_id}/${data?.cart[0]?.sku}`
            }
            className="uppercase w-44 py-1.5 px-5 rounded-none text-sm lg:mt-4 emd:mt-0 small:mt-0"
            disabled={
              data?.cart[0]?.orderStatus === "Returned" ||
              data?.cart[0]?.orderStatus === "Return Initiated" ||
              data?.cart[0]?.orderStatus === "Exchange Initiated" ||
              data?.cart[0]?.orderStatus === "Cancelled" ||
              data?.cart[0]?.orderStatus === "Exchanged" ||
              (data?.cart[0]?.orderStatus === "Placed" &&
                isMoreThan24Hours(data?.createdAt))
            }
          />
        </div>
      )}
    </div>
    <div className="w-full">
      {data?.cart[0]?.lensDetails && (
        <div className="mt-5 flex flex-col">
          <span className="text-lg font-semibold">Lens Details :</span>
          {data?.cart[0]?.lensDetails?.map((item, index) => {
            return (
              <div key={index} className="flex mt-2 ms-3">
                <span className="text-base">{index + 1}.&nbsp;</span>
                <div className="flex flex-col">
                  <span className="text-base font-semibold">
                    {item?.name}{" "}
                    <span className="ms-1 text-base font-semibold">{`(₹ ${item?.price})`}</span>
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div className="w-full border-light_secondary border-t pt-4 mt-4">
        {data?.deliveryDate &&
        (data?.cart[0]?.orderStatus === "Placed" ||
          data?.cart[0]?.orderStatus === "In Making" ||
          data?.cart[0]?.orderStatus === "Prepared") ? (
          <span className="text-base text-primary">
            Your Scheduled delivery date is{" "}
            {formatedSchedualeDeliveryDate(data?.deliveryDate)}
          </span>
        ) : (
          <span className="text-base text-primary">
            {data?.cart[0]?.orderStatus === "Placed" ||
            data?.cart[0]?.orderStatus === "In Making" ||
            data?.cart[0]?.orderStatus === "Prepared"
              ? `Order ${data?.cart[0]?.orderStatus} : Estimated delivery by ${formattedEstimatedDeliveryDate}`
              : data?.cart[0]?.orderStatus === "Delivered"
              ? `Order ${data?.cart[0]?.orderStatus}`
              : `Order ${data?.cart[0]?.orderStatus}`}
          </span>
        )}
      </div>
    </div>
  </div>
</div>
</div> */
}

// ================================================= mobile ui ===================================================

{
  /* <div className="w-full mt-5 lg:hidden emd:flex small:flex items-start flex-col justify-between  bg-bg_1 p-8">
<div className="w-full flex flex-col">
  <div className="w-full flex emd:flex-row small:flex-col items-center justify-center overflow-hidden">
    <img
      src={data?.cart[0]?.images?.[0].replace(
        "upload/",
        "upload/if_w_gt_300/w_300/if_end/"
      )}
      alt=""
      className="w-[250px] emd:h-[150px] small:h-[100px] object-contain"
    />
    {data?.cart[0]?.lensDetails && (
      <div className="flex emd:flex-row small:flex-col items-center justify-start emd:ms-5 small:ms-0">
        <div className="emd:text-3xl small:text-xl bg-[#dfdfe0] rounded-full emd:min-w-[30px] emd:max-w-[30px] emd:min-h-[30px] emd:max-h-[30px] small:min-w-[25px] small:max-w-[25px] small:min-h-[25px] small:max-h-[25px] flex items-center justify-center text-center">
          +
        </div>
        <img
          src={data?.cart[0]?.lensDetails[0]?.image}
          alt=""
          className="min-w-[50px] max-w-[50px] emd:ms-5 small:mt-4 emd:mt-0 small:ms-0 bg-bg_1"
        />
      </div>
    )}
  </div>
  <div className="w-full emd:mt-4 small:mt-6 flex flex-col">
    <span className="text-lg font-semibold">
      {data?.cart[0]?.title}
    </span>
    <span className="text-sm">SKU : {data?.cart[0]?.sku}</span>
    <span className="text-sm">
      Quantity : {data?.cart[0]?.quantity}
    </span>
  </div>
  <div className="w-full">
    {data?.cart[0]?.lensDetails && (
      <div className="mt-4 flex flex-col">
        <span className="text-lg font-semibold">Lens Details :</span>
        {data?.cart[0]?.lensDetails?.map((item, index) => {
          return (
            <div key={index} className="flex mt-2 ms-3">
              <span className="text-base">{index + 1}.&nbsp;</span>
              <div className="flex flex-col">
                <span className="text-base font-semibold">
                  {item?.name}{" "}
                  <span className="ms-1 text-base font-semibold">{`(₹ ${item?.price})`}</span>
                </span>
              </div>
            </div>
          );
        })}
      </div>
    )}
  </div>
</div>
<div className="w-full border-light_secondary border-t mt-4 pt-4">
  {data?.deliveryDate &&
  (data?.cart[0]?.orderStatus === "Placed" ||
    data?.cart[0]?.orderStatus === "In Making" ||
    data?.cart[0]?.orderStatus === "Prepared") ? (
    <span className="text-base text-primary">
      Your Scheduled delivery date is{" "}
      {formatedSchedualeDeliveryDate(data?.deliveryDate)}
    </span>
  ) : (
    <span className="text-base text-primary">
      {data?.cart[0]?.orderStatus === "Placed" ||
      data?.cart[0]?.orderStatus === "In Making" ||
      data?.cart[0]?.orderStatus === "Prepared"
        ? `Order ${data?.cart[0]?.orderStatus} : Estimated delivery by ${formattedEstimatedDeliveryDate}`
        : data?.cart[0]?.orderStatus === "Delivered"
        ? `Order ${data?.cart[0]?.orderStatus}`
        : `Order ${data?.cart[0]?.orderStatus}`}
    </span>
  )}
</div>
{data?.cart[0]?.orderStatus === "Not Placed" ||
(!showReturnExchangeButton &&
  data?.cart[0]?.orderStatus === "Delivered") ? (
  <div className="flex text-center my-5"></div>
) : (
  <div className="w-full mt-5 flex justify-between items-center">
    <BTN
      title={
        data?.cart[0]?.orderStatus === "Placed" ||
        data?.cart[0]?.orderStatus === "In Making" ||
        data?.cart[0]?.orderStatus === "Prepared" ||
        data?.cart[0]?.orderStatus === "Pending"
          ? "Track Order"
          : "Return"
      }
      bordered
      to={
        data?.cart[0]?.orderStatus === "Placed" ||
        data?.cart[0]?.orderStatus === "In Making" ||
        data?.cart[0]?.orderStatus === "Prepared" ||
        data?.cart[0]?.orderStatus === "Pending"
          ? `/track-order/${data?.orderId}/${data?.cart[0]?.sku}`
          : `/return-order/${data?.orderId}/${data?.cart[0]?.product_id}/${data?.cart[0]?.sku}`
      }
      className="uppercase w-fit py-1.5 emd:px-5 small:px-1.5 rounded-none emd:text-sm small:text-xs"
      disabled={
        data?.cart[0]?.orderStatus === "Returned" ||
        data?.cart[0]?.orderStatus === "Return Initiated" ||
        data?.cart[0]?.orderStatus === "Exchange Initiated" ||
        data?.cart[0]?.orderStatus === "Cancelled" ||
        data?.cart[0]?.orderStatus === "Exchanged"
      }
    />

    <BTN
      title={
        data?.cart[0]?.orderStatus === "Placed" ||
        data?.cart[0]?.orderStatus === "In Making" ||
        data?.cart[0]?.orderStatus === "Pending"
          ? "Cancel Order"
          : "Exchange"
      }
      bordered
      to={
        data?.cart[0]?.orderStatus === "Placed" ||
        data?.cart[0]?.orderStatus === "In Making" ||
        data?.cart[0]?.orderStatus === "Prepared" ||
        data?.cart[0]?.orderStatus === "Pending"
          ? `/cancel-order/${data?.orderId}/${data?.cart[0]?.product_id}`
          : `/exchange-order/${data?.orderId}/${data?.cart[0]?.product_id}/${data?.cart[0]?.sku}`
      }
      className="uppercase w-fit py-1.5 emd:px-5 small:px-1.5 rounded-none emd:text-sm small:text-xs lg:mt-4 emd:mt-0 small:mt-0 ms-1"
      disabled={
        data?.cart[0]?.orderStatus === "Returned" ||
        data?.cart[0]?.orderStatus === "Return Initiated" ||
        data?.cart[0]?.orderStatus === "Exchange Initiated" ||
        data?.cart[0]?.orderStatus === "Cancelled" ||
        data?.cart[0]?.orderStatus === "Exchanged" ||
        (data?.cart[0]?.orderStatus === "Placed" &&
          isMoreThan24Hours(data?.createdAt))
      }
    />
  </div>
)}
</div> */
}
